import React from 'react';
import TextButton from '../projects/history/RecordLayout/TextButton';
import { useOpenUpdateFormHelper } from '../projects/view/tasks/CreateUpdate/OpenUpdateFormField';
import { useShowContextRequired } from 'ui-builder';
import { AbstractTask } from 'nekst-api';

export default function OpenTaskButton() {

  const openTaskHelper = useOpenUpdateFormHelper();
  const showContext = useShowContextRequired<AbstractTask>();

  return (
    <TextButton
      text="Go to task"
      onClick={() => {
        openTaskHelper.openForm(showContext.data);
      }}
    />
  );
}
